import React from 'react'
import "./faqs.scss"
import Accordion from 'react-bootstrap/Accordion';
import { Translation, useTranslation } from 'react-i18next';
const Faqs = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className='Main_faqs' id='faqs'>
                <div className='custom-container'>
                    <div className='inner_faqs'>
                        <div className='left_Side'>
                            <h2>{t('Frequently Asked Questions')}</h2>
                        </div>
                        <div className='right_side'>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header><span>01.</span>What exactly is the Rain Protocol?</Accordion.Header>
                                    <Accordion.Body>
                                        Rain is a decentralized infrastructure layer specifically designed for building prediction markets. Unlike end-user apps, Rain provides the SDKs, APIs, and smart contracts needed for anyone to launch their own markets.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header><span>02.</span>How do I start building on Rain?</Accordion.Header>
                                    <Accordion.Body>
                                        It’s simple. You can explore our documentation to integrate our SDK/API or register through the Builder Portal.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header><span>03.</span>Who can apply for the $5M Grants Program?</Accordion.Header>
                                    <Accordion.Body>
                                        We welcome developers, creators, and teams building unique applications on top of Rain. If your project brings value to the ecosystem, you may be considered for a grant.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header><span>04.</span>How does the revenue-sharing model work for builders?</Accordion.Header>
                                    <Accordion.Body>
                                       Rain is built to reward its ecosystem. Builders earn a certain percentage of the trading volume generated by their specific markets or applications.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header><span>05.</span>What makes Rain different from other prediction markets?</Accordion.Header>
                                    <Accordion.Body>
                                        Rain is a permissionless protocol. It allows users to create both private and public markets, integrates AI-powered automated resolution, and lets communities use their native token for trading.
                                    </Accordion.Body>
                                </Accordion.Item>
               

                            </Accordion>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Faqs


